import { defer, Observable, of, switchMap } from 'rxjs';

import { ChangeDetectionStrategy, Component, Inject, Input, Optional } from '@angular/core';

import { NZ_MODAL_DATA, NzModalService } from 'ng-zorro-antd/modal';

import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngxs/store';

import { PricingExamplesLegacyComponent } from '@app/client/settings/shared/modules/subscription/components/pricing-examples-legacy/pricing-examples-legacy.component';
import { PlatformImages } from '@app/core/models/common.models';
import { BillingVolumeType, CustomerSubscription, InvoiceCurrency } from '@app/core/models/customer.models';
import { SubscriptionState } from '@app/core/store/states/customer/subscription/subscription.state';
import { lastValue } from '@app/shared/operators/last-value.operator';

@Component({
  standalone: false,
  selector: 'adspt-pricing-details-self-service',
  templateUrl: 'pricing-details-self-service.component.html',
  styleUrls: ['pricing-details-self-service.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricingDetailsSelfServiceComponent {
  readonly checkoutCurrency$: Observable<InvoiceCurrency> = this.store.select(SubscriptionState.checkoutCurrency);

  readonly currency$ = defer(() =>
    of(this.subscription?.currency).pipe(switchMap((currency) => (currency ? of(currency) : this.checkoutCurrency$))),
  );

  @Input()
  newPlan?: boolean;

  @Input()
  subscription?: CustomerSubscription;

  readonly BillingVolumeType = BillingVolumeType;

  readonly PlatformImages = PlatformImages;

  constructor(
    private ms: NzModalService,
    private tl: TranslateService,
    @Optional() @Inject(NZ_MODAL_DATA) data: Partial<PricingDetailsSelfServiceComponent>,
    private store: Store,
  ) {
    Object.keys(data || {}).forEach((key) => (this[key] = data[key]));
  }

  onShowExample(): void {
    const currency = lastValue(this.currency$);

    this.ms.create({
      nzContent: PricingExamplesLegacyComponent,
      nzClassName: 'a-modal-hide-cancel a-modal-fit-content',
      nzOkText: lastValue(this.tl.get('common.close')),
      nzData: { currency },
    });
  }
}
